module.exports = __webpack_public_path__ + "img/logo03.c3e52af6.png";